import { render, staticRenderFns } from "./anComicPublish.vue?vue&type=template&id=04897c48"
import script from "./anComicPublish.vue?vue&type=script&lang=js"
export * from "./anComicPublish.vue?vue&type=script&lang=js"
import style0 from "./anComicPublish.vue?vue&type=style&index=0&id=04897c48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports